const PageStruct = {
    id: 'forgot-password',
    useLayout: true,
    children: [{ id: 'forgot-password', order: 1 }]
};

export default PageStruct;
